import { Link } from 'react-router-dom';
import { topics } from '@/mocks/navData';
import { getSitesByIds } from '@/utils/nav';

export default function TopicShowcase() {
  return (
    <section className="mt-10">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            主题合集
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            主题推荐专题
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            围绕使用场景精心整理的合集，帮你成组发现好用的网站。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {topics.map((topic) => (
          <article
            key={topic.id}
            className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
          >
            <div className="h-40 w-full shrink-0">
              <img
                src={topic.image}
                alt={`${topic.title} 专题配图`}
                title={`${topic.title} 蓝导航精选专题`}
                className="h-40 w-full object-cover object-top"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                {topic.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {topic.description}
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {getSitesByIds(topic.siteIds).map((site) => (
                  <Link
                    key={site.id}
                    to={`/detail/${site.id}`}
                    className="cursor-pointer rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:bg-primary-50 hover:text-primary-600"
                  >
                    {site.name}
                  </Link>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}